import React, { useEffect, useState } from "react";
import api from '../../../components/api'
import { onlyNumberWithDecimal, onlyNumberWithTwoDecimal, onlyNumberWithTwoDecimalNegative } from '../../../components/functions'
import InputMask from 'react-input-mask'
import { useSadtContext } from '../../../context/SadtContext'
import moment from 'moment'
import { useTabelaGestao } from '../../../context/GestaoPendenciasContext'

const Modal = (props) => {

    const energia_id = props.energia_id
    const adesao_institucional_id = props.adesao_institucional_id
    const ano = props.ano

    const { setAtualizacaoGestao } = useTabelaGestao()

    const { energiaEquipamento_id, setEnergiaEquipamento_id } = useSadtContext()


    const [resultadoEquipamentos, setResultadoEquipamentos] = useState([])
    
    const [anoFabricacao, setAnoFabricacao] = useState('')
    const [quantidade, setQuantidade] = useState('')
    const [rotuloTipoQtde, setRotuloTipoQtde] = useState('[Escolha um equipamento]')

    const [listaAnos, setListaAnos] = useState()

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [equipamentoCategoria, setEquipamentoCategoria] = useState('')
    const [equipamentoTipo_id, setEquipamentoTipo_id] = useState('')
    const [potenciaNominal, setPotenciaNominal] = useState('')
    const [consumoEnergia, setConsumoEnergia] = useState('')
    const [rotinaManutencao, setRotinaManutencao] = useState('')
    const [frequenciaUso, setFrequenciaUso] = useState('')
    //const [descricaoUso, setDescricaoUso] = useState('')
    const [entradaOperacao, setEntradaOperacao] = useState('')
    const [saidaOperacao, setSaidaOperacao] = useState('')

    const [procedimentosAno, setProcedimentosAno] = useState('')

    const [resultadoTipoEquipamento, setResultadoTipoEquipamento] = useState('')
    const [energiaEquipamentoTipo_id, setEnergiaEquipamentoTipo_id] = useState('')

    const [informa, setInforma] = useState(true)





    function carregaAnos() {

        var x_array = []

        for (var x = 1990; x <= 2030; x++) {
            
            x_array.push(x)

        }


        //console.log(x_array, 'aqui')
        setListaAnos(x_array.sort().reverse().map((ano) =>
        
            <option value={ano}>{ano}</option>
        
        ))
        

    }

    const handleChange = (e) => {
        e.preventDefault();
    }




    const alteraRotulo = () => {


        switch (equipamentoCategoria) {

            case 'Diagnóstico por Imagem':

                setRotuloTipoQtde('Número de exames ou procedimentos por ano')

            break

            case 'Terapias Especializadas':

                setRotuloTipoQtde('Número tratamentos por ano')

            break

            case 'Laboratório e Análises Clínicas':

                setRotuloTipoQtde('Número amostras analisadas/testes por ano')

            break

            case 'Outros Equipamentos Específicos':

                setRotuloTipoQtde('Número amostras analisadas/testes por ano')

            break



        }


    }

    


    useEffect(() => {

        if (equipamentoCategoria != '') {

            alteraRotulo()

        }

    }, [equipamentoCategoria])




    const carregaEquipamento = () => {

        if (energiaEquipamento_id) {



            api.get(`energiaEquipamentoListaUm/${energiaEquipamento_id}`).then((result) => {

                //console.log(result.data, '!!')
                var data = result.data[0]

                setEquipamentoCategoria(data.equipamentoCategoria)
                setEnergiaEquipamentoTipo_id(data.energiaEquipamentoTipo_id)
                setAnoFabricacao(data.anoFabricacao)
                setQuantidade(data.quantidade)
                setPotenciaNominal(data.potenciaNominal)
                setConsumoEnergia(data.consumoEnergia)
                setRotinaManutencao(data.rotinaManutencao)
                setFrequenciaUso(data.frequenciaUso)
                setProcedimentosAno(data.procedimentosAno)
                setEntradaOperacao(data.entradaOperacao)
                setSaidaOperacao(data.saidaOperacao)
                

            }).catch((err) => {

                console.log(err.response)

            })


        }


    }


    
    const carregaTipoEquipamentos = () => {

        //console.log('aqui')

        var dataPost = {

            equipamentoCategoria: equipamentoCategoria

        }

        api.post('energiaEquipamentoTipo', dataPost).then((result) => {

            //console.log(result.data)
            setResultadoTipoEquipamento(result.data.map((rs) =>
            
                <option value={rs.energiaEquipamentoTipo_id}>{rs.descricao}</option>
            
            ))

        }).catch((err) => {

            console.log(err.response)

        })

    }


    useEffect(() => {

        if (equipamentoCategoria != null && equipamentoCategoria != '') {

            carregaTipoEquipamentos()

        }

    }, [equipamentoCategoria])



    const limpa = () => {

        setEquipamentoCategoria('')
        setEnergiaEquipamentoTipo_id('')
        setAnoFabricacao('')
        setQuantidade('')
        setPotenciaNominal('')
        setConsumoEnergia('')
        setRotinaManutencao('')
        setFrequenciaUso('')
        setProcedimentosAno('')
        setEntradaOperacao('')
        setSaidaOperacao('')
        

        //setResultadoEquipamentos([])

    }



    const salva = () => {




        if (entradaOperacao != '') {


            if (entradaOperacao.indexOf('/') == -1) {

                window.toastr.error('Por favor, preencha o campo <b>Entrada em Operação</b> no formato correto: MM/AAAA!')
                return false

            } else {


                var x_array = entradaOperacao.split('/')
                var mesEntradaOperacao = x_array[0]

                

                //console.log(x_array, 'aqui..')

                if (parseInt(x_array[0]) > 12) {

                    window.toastr.error('Consta um mês inválido no campo <b>Entrada em Operação</b>!')
                    return false
    
                }  else {

                    var dataEntradaTemp = moment(`${x_array[1]}-${x_array[0]}-01`).format('YYYY-MM-DD')

                }


                if (anoFabricacao != '' && x_array[1] != '') {

                    var anoFabricacao_r = parseInt(anoFabricacao)

                    var anoEntradaOperacao = parseInt(x_array[1])

                    if (anoEntradaOperacao < anoFabricacao_r) {


                        window.toastr.error('O <b>Ano de entrada em operação</b> não pode ser anterior que o <b>ano de fabricação</b>!')
                        return false


                    }

                }


            }
            

        }


        if (saidaOperacao != '') {


            if (saidaOperacao.indexOf('/') == -1) {

                window.toastr.error('Por favor, preencha o campo <b>Saída de Operação</b> no formato correto: MM/AAAA!')
                return false

            } else {


                var x_array = saidaOperacao.split('/')

                //console.log(x_array, 'aqui..')

                if (parseInt(x_array[0]) > 12) {

                    window.toastr.error('Consta um mês inválido no campo <b>Saída de Operação</b>!')
                    return false
    
                }


                if (anoEntradaOperacao != '' && x_array[1] != '' && x_array[0] != '' && mesEntradaOperacao != '') {
                
                    var anoSaidaOperacao = parseInt(x_array[1])
                    var mesSaidaOperacao = parseInt(x_array[0])

                    if (anoSaidaOperacao < anoEntradaOperacao) {

                        window.toastr.error('Data de saída de operação precisa ser posterior a data de enetrada em operação!')
                        return false

                    } else {

                        var dataSaidaTemp = moment(`${x_array[1]}-${x_array[0]}-01`).format('YYYY-MM-DD')
                        //console.log(dataEntradaTemp, dataSaidaTemp)

                        //console.log('aqui..')

                        if (dataSaidaTemp < dataEntradaTemp) {

                            window.toastr.error('Data de saída de operação precisa ser posterior a data de enetrada em operação!')
                            return false

                        }

                        /*
                        if (mesSaidaOperacao < parseInt(mesEntradaOperacao)) {

                            window.toastr.error('Data de saída de operação precisa ser posterior a data de enetrada em operação!')
                            return false

                        }
                        */


                    }


                }


            }
            

        }

        if (equipamentoCategoria == '') {

            window.toastr.error('<b>Quantidade</b> não pode ficar em branco!')
            return false

        }

        if (equipamentoTipo_id == '') {

            window.toastr.error('<b>Tipo de equipamento</b> não pode ficar em branco!')
            return false

        }


        if (anoFabricacao == '') {

            window.toastr.error('<b>Ano de fabricação</b> não pode ficar em branco!')
            return false

        }


        

        var dataPost = {

            energia_id: energia_id,
            adesao_institucional_id: adesao_institucional_id,
            ano: ano,
            equipamentoCategoria: equipamentoCategoria,
            //equipamentoTipo_id: equipamentoTipo_id,
            anoFabricacao: anoFabricacao,
            quantidade: quantidade,
            potenciaNominal: potenciaNominal,
            consumoEnergia: consumoEnergia,
            rotinaManutencao: rotinaManutencao,
            frequenciaUso: frequenciaUso,
            energiaEquipamentoTipo_id: energiaEquipamentoTipo_id,
            //descricaoUso: descricaoUso,
            procedimentosAno: procedimentosAno,
            entradaOperacao: entradaOperacao,
            saidaOperacao: saidaOperacao,


        }

        //console.log(dataPost)
        //return false



        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
		    title: 'Confirmação',
		    content: 'Confirma salvar?',
		    buttons: {
		        Sim: function () {

                            
                    if (energiaEquipamento_id) {

                        //console.log(dataPost)

                        api.put(`energiaEquipamento/${energiaEquipamento_id}`, dataPost).then((result) => {

                            console.log(result.data)
                            //setShow(false)
                            window.$('#modalSADT').modal('hide')
                            //consultaEquipamentos()
                            setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))
                            window.toastr.success('Registro salvo com sucesso!')

                        }).catch((err) => {

                            console.log(err.response)

                        })

                    } else {


                        api.post('energiaEquipamento', dataPost).then((result) => {

                            console.log(result.data)
                            //setShow(false)
                            window.$('#modalSADT').modal('hide')
                            //consultaEquipamentos()
                            setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))
                            window.toastr.success('Registro salvo com sucesso!')

                        }).catch((err) => {

                            console.log(err.response)

                        })


                    }
                    
                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });

    }

    const apaga = () => {


        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'red',
		    title: 'Confirmação',
		    content: 'Confirma apagar?',
		    buttons: {
		        Sim: function () {



                    api.delete(`energiaEquipamento/${energiaEquipamento_id}`).then((result) => {

                        //setShow(false)
                        //consultaEquipamentos()
                        window.$('#modalSADT').modal('hide')
                        setAtualizacaoGestao(Math().random)
                        window.toastr.success('Registro apagado com sucesso!')

                    }).catch((err) => {

                        console.log(err.response)

                    })
                    
                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });


    }


    useEffect(() => {

        limpa()
        carregaEquipamento()
        //console.log(energiaGerador_id, '!!')
        

    }, [energiaEquipamento_id])


    useEffect(() => {

        
        carregaAnos()
        carregaTipoEquipamentos()

    }, [])


    useEffect(() => {

        limpa()
        //consultaEquipamentos()
        //consultaInforma()
        //consultaGeradores()
        //consultaInforma()

    }, [ano, energia_id])


    return (

        <div>

                <div className="modal fade" id="modalSADT" tabindex="-1" role="dialog" aria-hidden="true" data-focus="true" >
                    <div className="modal-dialog modal-lg" role="document" >
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                <h1 className="modal-title">Equipamento SADT</h1>
                            </div>
                            <div className="modal-body">


                            <div className="row">


                                <div className="col-md-12" >
                                        <b>Dados básicos</b>
                                        <br/><br/>
                                </div>
                                    
                                    
                                    <div className="col-md-4" >
                                        <div class="form-group" >
                                        
                                            <label className="control-label">Categoria do Equipamento *</label>
                                            <select class="form-control" value={equipamentoCategoria} onChange={event => setEquipamentoCategoria(event.target.value)}>
                                                <option value="">[Selecione]</option>
                                                <option value="Diagnóstico por Imagem">Diagnóstico por Imagem</option>
                                                <option value="Terapias Especializadas">Terapias Especializadas</option>
                                                <option value="Laboratório e Análises Clínicas">Laboratório e Análises Clínicas</option>
                                                <option value="Outros Equipamentos Específicos">Outros Equipamentos Específicos</option>
                                                
                                            </select>
                                                
                                        </div>
                                    </div>

                                    <div className="col-md-4" >
                                        <div class="form-group" >
                                        
                                            <label className="control-label">Tipo de Equipamento *</label>
                                            <select className="form-control" value={energiaEquipamentoTipo_id} onChange={event => setEnergiaEquipamentoTipo_id(event.target.value)}>
                                                <option value="">[Selecione]</option>
                                                {resultadoTipoEquipamento}
                                            </select>
                                                
                                                
                                        </div>
                                    </div>

                                    <div className="col-md-4" >
                                        <div class="form-group" >
                                        
                                            <label className="control-label">Ano de Fabricação *</label>
                                            <select class="form-control" value={anoFabricacao} onChange={event => setAnoFabricacao(event.target.value)}>
                                                <option value="">[Selecione]</option>
                                                {listaAnos}
                                                <option value="0">Não informado</option>
                                            </select>
                                                
                                                
                                        </div>
                                    </div>

                                    <div className="col-md-3" >
                                        <div class="form-group" >
                                        <br/>
                                            <label className="control-label">Quantidade *</label>
                                            <input class="form-control" input="text" value={quantidade} onChange={event => setQuantidade(event.target.value)}
                                            onCut={handleChange}
                                            onCopy={handleChange}
                                            onPaste={handleChange}
                                            onKeyPress={(event) => {
                                                if (!/[0-9]/.test(event.key)) {
                                                event.preventDefault();
                                                }
                                            }} 
                                            />
                                                
                                        </div>
                                    </div>

                                
                                <div className="col-md-12" >
                                    <br/><br/>
                                    <b>Dados Técnicos</b>
                                    <br/><br/>
                                </div>
                                    
                                    
                                    <div className="col-md-6" >
                                        <div class="form-group" >
                                        
                                            <label className="control-label">Potência nominal [kW] *</label>
                                            <input class="form-control"  value={potenciaNominal} onChange={event => setPotenciaNominal(event.target.value)} />
                                                
                                                
                                        </div>
                                    </div>
                                    <div className="col-md-6" >
                                        <div class="form-group" >
                                        
                                            <label className="control-label">Consumo de Energia por uso</label>
                                            <input class="form-control"  value={consumoEnergia} onChange={event => setConsumoEnergia(event.target.value)} />
                                                
                                                
                                        </div>
                                    </div>
                                    

                                <div className="col-md-12" >
                                    <br/><br/>
                                    <b>Dados Operacionais</b>
                                    <br/><br/>
                                </div>

                                    <div className="col-md-6" >
                                        <div class="form-group" >
                                        
                                            <label className="control-label">Rotina de Manutenção *</label>
                                            <select class="form-control"  value={rotinaManutencao} onChange={event => setRotinaManutencao(event.target.value)} >
                                                <option value="">[Selecione]</option>
                                                <option value="Periódica Semanal">Periódica Semanal</option>
                                                <option value="Periódica Mensal">Periódica Mensal</option>
                                                <option value="Periódica Anual">Periódica Anual</option>
                                                <option value="Corretiva (mediante falha)">Corretiva (mediante falha)</option>
                                                
                                            </select>
                                                
                                        </div>
                                    </div>




                                    <div className="col-md-6" >
                                        <div class="form-group" >
                                        
                                            <label className="control-label">Frequência de uso *</label>
                                            <input class="form-control" 
                                            value={frequenciaUso} onChange={event => setFrequenciaUso(event.target.value)} 
                                            onCut={handleChange}
                                            onCopy={handleChange}
                                            onPaste={handleChange}
                                            onKeyPress={(event) => {
                                                if (!/[0-9]/.test(event.key)) {
                                                event.preventDefault();
                                                }
                                            }} 
                                            />
                                                
                                                
                                        </div>
                                    </div>

                                    <div className="col-md-12" >
                                        <div class="form-group" >
                                            <br/>
                                            <label className="control-label">{rotuloTipoQtde}</label>
                                            <input class="form-control" 
                                            value={procedimentosAno} onChange={event => setProcedimentosAno(event.target.value)} 
                                            onCut={handleChange}
                                            onCopy={handleChange}
                                            onPaste={handleChange}
                                            onKeyPress={(event) => {
                                                if (!/[0-9]/.test(event.key)) {
                                                event.preventDefault();
                                                }
                                            }} 
                                            />
                                                
                                                
                                        </div>
                                    </div>


                                        <div className="col-md-6" >
                                            <div class="form-group" >
                                                <br/>
                                                <label className="control-label">

                                                    <span class="wrapper2">
                                                        Entrada em operação (Mês/Ano)
                                                        <div class="tooltip">
                                                        insira a data (mês e ano) quando o equipamento entrou em operação na unidade.


                                                        </div>
                                                    </span>

                                                </label>

                                                
                                                <InputMask mask="99/9999" class="form-control" value={entradaOperacao} onChange={event => setEntradaOperacao(event.target.value)}  />
                                                    
                                            </div>
                                        </div>
                                        <div className="col-md-6" >
                                            <div class="form-group" >
                                                <br/>
                                                <label className="control-label">

                                                    <span class="wrapper2">
                                                        Saída de operação (Mês/Ano)
                                                        <div class="tooltip">
                                                        Insira a data (mês e ano) quando o equipamento saiu de operação na unidade. Deixar em branco caso ainda esteja em operação.


                                                        </div>
                                                    </span>

                                                </label>
                                                
                                                <InputMask mask="99/9999" class="form-control" value={saidaOperacao} onChange={event => setSaidaOperacao(event.target.value)}  />
                                                    
                                            </div>
                                        </div>



                            </div>



                            </div>
                            <div className="modal-footer">
                            <button type="button" className="btn btn-danger" onClick={() => apaga()} style={{ display: energiaEquipamento_id ? 'table-row' : 'none'}}>Apagar</button>
                                <button type="button" className="btn btn-success" onClick={() => salva()}>Salvar</button>
                                <button type="button" className="btn btn-secondary" data-dismiss="modal">Fechar</button>


                                
                            </div>
                        </div>
                    </div>
                </div>


        </div>

    )

}


export default Modal